import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import MyRoom_admin from './MyRoom_admin';
import './AdminLayout.scss';

const AdminLayout = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const location = useLocation();
    const isNoScrollContentRoute =
        location.pathname.startsWith('/admin/users')
        || location.pathname.startsWith('/admin/login-history');
    const isSmsContentRoute = location.pathname.startsWith('/admin/sms');

    return (
        <div className="admin-layout">
            {/* ����� ��� ��� �� */}
            <div className="mobile-topbar">
                <button
                    className="btn-mobile-sidebar-toggle"
                    onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                >
                    {isSidebarOpen ? <FaTimes /> : <FaBars />}
                </button>
            </div>

            {/* ����� �������� */}
            {isSidebarOpen && (
                <div className="mobile-sidebar-overlay" onClick={() => setIsSidebarOpen(false)} />
            )}

            <aside className={`sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}>
                <MyRoom_admin closeMobileMenu={() => setIsSidebarOpen(false)} />
            </aside>
            <main className={`content ${isNoScrollContentRoute ? 'content-users-no-scroll' : ''} ${isSmsContentRoute ? 'content-sms-mobile-pad' : ''}`}>
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
